import styled, { useTheme } from "styled-components";
import React, { useContext } from "react";
import { components } from "react-select";
import { Icon } from "@fluentui/react";
import { Select } from "../Select";
import { ColumnOptionsContext } from "./ColumnOptions";
import { IStyledTheme } from "../../theme/types";

export const ViewSelect = ({ className }: { className?: string }) => {
  const theme = useTheme() as IStyledTheme;
  const {
    views,
    selectedView,
    isViewLoading,
    onChangeView,
    strings,
    hideViewOptionsFeatures,
    usePlaceholder,
    id,
  } = useContext(ColumnOptionsContext);

  const options = views.map((v) => ({
    label: v.name,
    value: v.id,
    isDefault: v.isDefault,
  }));

  let selectedOption: any = null;
  if (selectedView !== null && selectedView !== undefined) {
    selectedOption = {
      value: selectedView.id,
      label: selectedView.name,
      isDefault: selectedView.isDefault,
    };
  } else if (!usePlaceholder) {
    selectedOption = {
      value: "default",
      label: "Default",
    };
  }

  const isLoading = isViewLoading;
  const isDisabled = isLoading;
  const isDark = theme?.isDark || false;

  return (
    <ViewSelectContainer className={className}>
      {!hideViewOptionsFeatures && (
        <Select
          value={selectedOption}
          onChange={(o: any) => {
            onChangeView(o ? o.value : null);
          }}
          options={options}
          noOptionsMessage={() => strings.viewSelectNoViewsLabel}
          placeholder={strings.viewSelectPlaceholder}
          isSearchable={options.length > 8}
          isClearable={!!selectedView}
          loadingMessage={() => strings.viewSelectLoadingLabel}
          isDisabled={isDisabled}
          isLoading={isLoading}
          styles={{
            menu: (provided: any) => ({
              ...provided,
              backgroundColor: isDark ? "#292827" : "white",
              zIndex: 9999,
            }),
            menuList: (provided: any) => ({
              ...provided,
              backgroundColor: isDark ? "#292827" : "white",
            }),
            option: (provided: any, state: any) => ({
              ...provided,
              backgroundColor: state.isSelected
                ? isDark
                  ? "#3b3a39"
                  : "rgb(237, 235, 233)"
                : state.isFocused
                ? isDark
                  ? "#201f1e"
                  : "rgb(243, 242, 241)"
                : isDark
                ? "#292827"
                : "white",
              "&:hover": {
                backgroundColor: state.isSelected
                  ? isDark
                    ? "#3b3a39"
                    : "rgb(237, 235, 233)"
                  : isDark
                  ? "#201f1e"
                  : "rgb(243, 242, 241)",
              },
            }),
          }}
          components={{
            Option: CustomOption,
            SingleValue: CustomSingleValue,
            DropdownIndicator: (props: any) => (
              <components.DropdownIndicator {...props}>
                <span style={{ fontSize: "12px" }}>▼</span>
              </components.DropdownIndicator>
            ),
          }}
        />
      )}
    </ViewSelectContainer>
  );
};

const ViewSelectContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const CustomOption = (props: any) => {
  return (
    <components.Option {...props}>
      <OptionContent>
        {props.data.isDefault && <StarIcon />}
        {props.children}
      </OptionContent>
    </components.Option>
  );
};

const CustomSingleValue = (props: any) => {
  return (
    <components.SingleValue {...props}>
      <SingleValueContent>
        {props.data.isDefault && <StarIcon />}
        {props.children}
      </SingleValueContent>
    </components.SingleValue>
  );
};

const StarIcon = () => (
  <Icon
    iconName="FavoriteStarFill"
    styles={{
      root: {
        fontSize: 16,
        color: "inherit",
      },
    }}
  />
);

const OptionContent = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const SingleValueContent = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;
